module.exports = __webpack_public_path__ + "img/light.b7a7ac10.png";